import { Controller } from "stimulus"
import {DataTable} from "simple-datatables"
import { recipientTemplate, callerTemplate } from '../../js/guestlist_templates';
import Choices from 'choices.js';

export default class extends Controller {
  static targets = ["recipientList", "callerList", "form", "callerId", "recipientId", "callerError", "recipientError"]

  initialize() {
    this.caller = null;
    this.recipient = null;
    this.setModalInputsAutofocus();
    this.recipientDataTable = new DataTable("#addRecipientTable", {
      perPage: 15,
      perPageSelect: false,
      labels: {
        noRows: "No contacts found",
        info: "Showing {start} to {end} of {rows} contacts"
      }
    });
    this.callerDataTable = new DataTable("#addCallerTable", {
      perPage: 15,
      perPageSelect: false,
      labels: {
        noRows: "No contacts found",
        info: "Showing {start} to {end} of {rows} contacts"
      }
    });
    this.setupDataTableSearch();
    this.initChoicesJS();
  }

  submitBefriendingMatch(event){
    event.preventDefault();
    this.caller ? this.callerErrorTarget.classList.add('d-none') : this.callerErrorTarget.classList.remove('d-none')
    this.recipient ? this.recipientErrorTarget.classList.add('d-none') : this.recipientErrorTarget.classList.remove('d-none')
    if (this.caller && this.recipient) { this.formTarget.submit() }
  }

  addRecipient(event) {
    let contact = JSON.parse(event.currentTarget.dataset.value)
    this.recipient = {
      id: contact.id,
      name: contact.name,
      dialout: false
    }
    document.getElementById('closeRecipientModal').click();
    this.setRecipientsAndCaller();
  }

  removeRecipient(event) {
    this.recipientListTarget.innerHTML = '';
    this.setAddButton(this.recipient.id, true)
    this.recipient = null;
    this.setRecipientsAndCaller();
    document.getElementById('addRecipientModalLaunch').style.setProperty('display', 'inline-flex', 'important');
    document.getElementById('addRecipientModalLaunch').setAttribute('aria-hidden', 'false');
  }

  addCaller(event) {
    let contact = JSON.parse(event.currentTarget.dataset.value);
    this.caller = {
      id: contact.id,
      name: contact.name,
      dialout: false
    }
    document.getElementById('closeCallerModal').click();
    this.setRecipientsAndCaller();
  }

  removeCaller() {
    this.callerListTarget.innerHTML = '';
    this.setAddButton(this.caller.id, true)
    this.caller = null;
    this.setRecipientsAndCaller();
    document.getElementById('addCallerModalLaunch').style.setProperty('display', 'inline-flex', 'important');
    document.getElementById('addCallerModalLaunch').setAttribute('aria-hidden', 'false');
  }

  setRecipientsAndCaller(){
    if (this.caller) { 
      this.callerListTarget.innerHTML = callerTemplate([this.caller], 'befriending--new') 
      document.getElementById('addCallerModalLaunch').style.setProperty('display', 'none', 'important');
      document.getElementById('addCallerModalLaunch').setAttribute('aria-hidden', 'true');
      this.setAddButton(this.caller.id, false)
      this.callerIdTarget.value = this.caller.id
    } else {
      this.callerIdTarget.value = '';
    };
    if (this.recipient) { 
      this.recipientListTarget.innerHTML = recipientTemplate([this.recipient], 'befriending--new');
      document.getElementById('addRecipientModalLaunch').style.setProperty('display', 'none', 'important');
      document.getElementById('addRecipientModalLaunch').setAttribute('aria-hidden', 'true');
      this.setAddButton(this.recipient.id, false)
      this.recipientIdTarget.value = this.recipient.id
    } else {
      this.recipientIdTarget.value = '';
    };
  }

  setAddButton(id, activate){
    let callerAddButton = document.getElementById(`callerAddButton${id}`);
    let recipientAddButton = document.getElementById(`recipientAddButton${id}`);
    if (callerAddButton) { 
      callerAddButton.innerHTML = activate ? '<i class="fas fa-plus me-1"></i> Add' : 'Added'
      callerAddButton.disabled = activate ? false : true
    }
    if (recipientAddButton) { 
      recipientAddButton.innerHTML = activate ? '<i class="fas fa-plus me-1"></i> Add' : 'Added'
      recipientAddButton.disabled = activate ? false : true
    }
  }

  setModalInputsAutofocus(){
    let callerModal = document.getElementById('addCallerModal')
    let recipientModal = document.getElementById('addRecipientModal')
    callerModal.addEventListener('shown.bs.modal', function (event) {
      event.target.querySelector("[autofocus]").focus();
    })
    recipientModal.addEventListener('shown.bs.modal', function (event) {
      event.target.querySelector("[autofocus]").focus();
    })
  }

  setupDataTableSearch() {
    let callerSearchBar = document.getElementById('addCallerSearchBar');
    callerSearchBar.addEventListener('keyup', (e) => {
      let addCallerTableSearch = document.getElementsByClassName('dataTable-input')[0];
      addCallerTableSearch.value = callerSearchBar.value;
      addCallerTableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
    let recipientSearchBar = document.getElementById('addRecipientSearchBar');
    recipientSearchBar.addEventListener('keyup', (e) => {
      let addRecipientTableSearch = document.getElementsByClassName('dataTable-input')[1];
      addRecipientTableSearch.value = recipientSearchBar.value;
      addRecipientTableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
  }

}